import styled from 'styled-components';

import { Paragraph } from 'ggApp/shared/common/Typography';
import { DropDown as DropDownComponent } from '@getgrover/ui';

export const DropDown = styled(DropDownComponent)`
   margin-bottom: 16px;
`;

export const ItemText = styled(Paragraph)`
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const WhiteColoursDictionary = {
    '#fff': true,
    '#FFF': true,
    '#ffffff': true,
    '#FFFFFF': true,
};

export const Circle = styled.div`
    min-width: 20px;
    min-height: 20px;
    background: ${({ variantColor }) => (variantColor)};
    border: 2px solid  ${({ theme, variantColor }) => (
        (WhiteColoursDictionary[variantColor]) ? `${theme.colors['Level 3']}` : 'transparent'
    )};
    box-shadow: 0 0 0 2px white;
    border-radius: 24px;
    box-sizing: border-box;
`;

